import { createFileRoute } from '@tanstack/react-router';

import { CategoryEditPage } from '@/components/admin/category-edit-page';
import { useAdminEditPageKey } from '@/hooks/use-admin-navigate';
import { adminHead } from '@/lib/seo';
import { adminGetCategoryFn } from '@/server/functions/admin';

export const Route = createFileRoute('/_admin/admin/categories_/$id')({
    component: CategoryEditRoute,
    head: ({ params }) =>
        adminHead(
            params.id === 'new' ? 'קטגוריה חדשה' : 'עריכת קטגוריה',
            `/admin/categories/${encodeURIComponent(params.id)}`,
        ),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: async ({ params }) => {
        if (params.id === 'new') return null;
        return adminGetCategoryFn({ data: { id: params.id } });
    },
});

function CategoryEditRoute() {
    const category = Route.useLoaderData();
    const formKey = useAdminEditPageKey(
        category ? `${category.id}:${String(category.updatedAt)}` : undefined,
    );
    return <CategoryEditPage key={formKey} category={category} />;
}
